import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Buffer } from 'buffer';
import Loading from './loading';
import ImageViewer from './Modals/ImageViewer';

const NewGallery = ({ currentUser, socket, setBanner, banner }) => {

    const [reload, setReload] = useState(true);

    useEffect(() => {
        if (reload) {
            setBanner({ ...banner, loading: false, id: 0 });
            setReload(false);
            window.scrollTo(0, 0);
        }
    }, [setBanner, setReload, banner, reload]);

    const [loading, setLoading] = useState(true);

    const [images, setImages] = useState([]);

    const [imageViewer, setImageViewer] = useState({
        show: false,
        image: null
    });

    const [uploadImages, setUploadImages] = useState({});

    const handleUpload = e => {
        e.preventDefault();
        socket.emit('store images', uploadImages);
        socket.on('images stored', () => {
            setUploadImages({});
            setImages([]);
            setLoading(true);
        });
    }

    const removeImage = e => {
        const payload = {
            image: e,
            userId: currentUser.user._id
        };
        socket.emit('remove image', payload);
        socket.on('image removed', () => {
            setImages([]);
            setLoading(true);
        });
    }

    const setFiles = e => {
        setUploadImages(e);
    };

    useEffect(() => {
        if (loading && !images.length) {
            socket.emit('load images');
            socket.on('images loaded', data => {
                setImages(data);
                setLoading(false);
            });
        }
    });

    const galleryImages = images.filter(data => data.image && data.type === "gallery");

    return (
        <Box>
            {!loading ? (
                <>
                    {(currentUser.isAuthenticated && currentUser.user.isAdmin > 8 && currentUser.adminSettings) && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <Card sx={{ width: '100%', maxWidth: 480 }}>
                                <CardContent>
                                    <Box component="form" onSubmit={handleUpload}>
                                        <Stack spacing={2}>
                                            <input
                                                onChange={e => { setFiles(e.target.files) }}
                                                id='fileUpload'
                                                type='file'
                                                multiple
                                                accept='image/png,image/jpeg,image/webp,image/bmp'
                                            />
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Button type="submit" variant="contained">Upload</Button>
                                            </Box>
                                        </Stack>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    )}
                    <Grid container spacing={2}>
                        {galleryImages.map((data, index) => (
                            <Grid key={data._id ?? index} size={{ xs: 12, sm: 6, md: 4 }}>
                                <Card>
                                    <CardActionArea onClick={() => setImageViewer({ show: true, image: data.image })}>
                                        <Box
                                            component="img"
                                            sx={{ width: '100%', height: 'auto', display: 'block' }}
                                            src={`data:image/png;base64,${Buffer.from(data.image).toString('base64')}`}
                                        />
                                    </CardActionArea>
                                    {(imageViewer.show && data.image === imageViewer.image) && (
                                        <ImageViewer
                                            image={data.image}
                                            imageViewer={imageViewer}
                                            setImageViewer={setImageViewer}
                                        />
                                    )}
                                    {(currentUser.isAuthenticated && currentUser.user.isAdmin > 8 && currentUser.adminSettings) && (
                                        <Box sx={{ p: 1 }}>
                                            <Button
                                                fullWidth
                                                color="error"
                                                variant="outlined"
                                                onClick={() => removeImage(data._id)}
                                            >
                                                Delete
                                            </Button>
                                        </Box>
                                    )}
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                    {galleryImages.length === 0 && (
                        <Typography align="center" sx={{ mt: 5 }}>No images yet.</Typography>
                    )}
                </>
            ) : (
                <Loading />
            )}
        </Box>
    );
}

export default NewGallery;
